import ClientRetainerTaskModal from './ClientRetainerTaskModal';
import ClientConsentFormTaskModal from './ClientConsentFormTaskModal';
import IdentityVerificationTaskModal from './IdentityVerificationTaskModal';
import SourceOfFundsTaskModal from './SourceOfFundsTaskModal';

import { useDispatch } from 'react-redux';


const ClientTasks = () => {

    const dispatch = useDispatch();

    return (
        <>
            <ClientRetainerTaskModal dispatch={dispatch} />
            <ClientConsentFormTaskModal dispatch={dispatch} />
            <IdentityVerificationTaskModal dispatch={dispatch} />
            <SourceOfFundsTaskModal dispatch={dispatch} />
        </>
    );
}

export default ClientTasks;
